


































































import Vue, { PropType } from 'vue'
import Person from '@/types/Person.interface'
export default Vue.extend({
    props: {
        person: {
            type: Object as PropType<Person>,
            default: null
        }
    },
    data() {
        return {
            link: null,
            step: 1,
            webLink: null
        }
    },
    methods: {
        copy(type: string): void {
            //  Get the 'reseller-link' html element
            let txt = document.getElementById(`${type}-link`) as HTMLInputElement

            //  Copy the link to the clipboard
            txt.select()
            txt.setSelectionRange(0, 99999)
            document.execCommand('copy')

            //  Notify the user the link has been copied to the clipboard
            this.$store.commit('appNotificationBarSet', {
                message: 'Short Link Copied to Clipboard!',
                type: 'success'
            })
        },
        async postRoute(): Promise<void> {
            //  Validate the form
            const valid = await this.$validator.validate()

            //  If the form is NOT valid, do nothing
            if (!valid) return

            //  Send off our request
            const route = await this.$store.dispatch('routesPost', { url: this.link })

            //  If it failed, do nothing
            if (!route) return

            //  Save our link if successful
            this.webLink = route.local_link

            //  Notify user that the route was saved
            this.$store.commit('appNotificationBarSet', {
                message: 'Web Link successfully saved!',
                type: 'success'
            })
        }
    }
})
